import {
    Injectable,
    inject,
    makeStateKey,
    PLATFORM_ID,
    TransferState,
} from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import { Config } from './config';
import { ContentService, TranslationApiRecord } from './content';

export type RegionLang = string;
export type TranslationKey = string;

const TRANSLATIONS_KEY =
    makeStateKey<Record<string, TranslationApiRecord[]>>('TRANSLATIONS_KEY');

@Injectable()
export class Translations {
    dictionary!: Record<string, TranslationApiRecord[]>;
    private platformId = inject(PLATFORM_ID);
    private transferState = inject(TransferState);

    constructor(
        private contentService: ContentService,
        private config: Config,
    ) {}

    async load(): Promise<void> {
        if (isPlatformBrowser(this.platformId)) {
            const transferredData = this.transferState.get(
                TRANSLATIONS_KEY,
                null,
            );

            if (transferredData) {
                this.transferState.remove(TRANSLATIONS_KEY);
                this.dictionary = transferredData;
                return;
            }
        }

        const [lang, sbu] =
            this.config.languages[
                this.config.getPreferredLanguage() ?? 'eng-WLD'
            ]?.fallback[0]?.split('-');

        this.dictionary = (await this.contentService.getContentP(
            sbu,
            lang,
        )) as Record<string, TranslationApiRecord[]>;

        if (isPlatformServer(this.platformId)) {
            this.transferState.set(TRANSLATIONS_KEY, this.dictionary);
        }
    }
}
